/**
 * Created by ty 879372858@qq.com on 18/2/1.
 */
// import BrowserContainer from './router/defaultRouter.js';
import Test from './views/home/index.vue'

export default Test;


// WEBPACK FOOTER //
// ./src/index.js